// extracted by mini-css-extract-plugin
export default {"clear":"reset_clear_5qUk-","clearfix":"reset_clearfix_I8DLa"};